"use strict";
exports.__esModule = true;
exports["default"] = {
    DigiByte: "1.3.19",
    Litecoin: "1.3.19"
};
//# sourceMappingURL=nativeSegwitAppsVersionsMap.js.map